import Backbone from 'backbone';

class AnswerModel extends Backbone.Model {
  initialize() {}
}

export default AnswerModel;
